import request from '@/utils/request'

// 查询轮播图列表（PC 管理端）
export function listWechatAdverts(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/wechatAdvert.listWechatAdverts',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.adverts || [],
        total: res.total || 0
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 发布轮播图
export function saveWechatAdvert(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/wechatAdvert.saveWechatAdvert',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to save'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新轮播图
export function updateWechatAdvert(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/wechatAdvert.updateWechatAdvert',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to update'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除轮播图
export function deleteWechatAdvert(wechatAdvertId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/wechatAdvert.deleteWechatAdvert',
      method: 'post',
      data: { wechatAdvertId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to delete'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
